import React from "react";
import "../../../../app/custom.scss";
import SentimentCard from "./SentimentCard";
import InfoCard from "./InfoCard";
import { useSelector } from "react-redux";
import ErrorBoundary from "../../../../ErrorBoundary";
import {
  getPaneIndex,
  getWindowLocationPath,
} from "../../../../redux/constants";
import { Skeleton } from "antd";
import isEqual from "react-fast-compare";

const InfoBar = (props) => {
  const panes = useSelector((state) => state.Tab1.panes); //all tabs data
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const screen = useSelector((state) => state?.Screens?.screen);
  let index = getPaneIndex(panes, activeKey);
  let pathName = getWindowLocationPath()?.toLowerCase();

  const infoBarData =
    pathName === "CommandCenter"?.toLowerCase()
      ? screen?.deep_dive?.infoBar
      : shareTemplateData
      ? shareTemplateData?.deep_dive?.infoBar
      : panes?.[index]?.deep_dive?.infoBar;
  return (
    <>
      {infoBarData?.status === "successful" ? (
        <div className="pl-15 pr-15 pt-15 bg__gray">
          <div className="row">
            <div className="col-sm-12 col-lg-7 pr-md-0">
              <ErrorBoundary>
                <SentimentCard />
              </ErrorBoundary>
            </div>

            {shareTemplateData?.is_prolific_user_deep_dive ||
            panes?.[index]?.is_prolific_user_deep_dive ? (
              ""
            ) : (
              <div className="col-sm-12 col-lg-5 pr-md-0">
                <div className="d-md-flex">
                  <ErrorBoundary>
                    <InfoCard />
                  </ErrorBoundary>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="pl-15 pr-15 pt-15 bg__gray">
          <div className="row">
            <div className="col-sm-12 col-lg-7 pr-md-0">
              <div className="deepDive__info bg__white border border-radius-4 mb-xs-3 mb-sm-3 d-sm-flex d-md-flex align-items-center justify-content-between">
                <div className="deepDive__info-list pl-15 pr-15 mt-15 mb-15 border-right">
                  <div>
                    <Skeleton active size="small" paragraph={{ rows: 1 }} />
                  </div>
                </div>
                <div className="deepDive__info-list pl-15 pr-15 mt-15 mb-15 border-right">
                  <div>
                    <Skeleton active size="small" paragraph={{ rows: 1 }} />
                  </div>
                </div>
                <div className="deepDive__info-list pl-15 pr-15 mt-15 mb-15 border-right">
                  <div>
                    <Skeleton active size="small" paragraph={{ rows: 1 }} />
                  </div>
                </div>
                <div className="deepDive__info-list pl-15 pr-15 mt-15 mb-15">
                  <div>
                    <Skeleton active size="small" paragraph={{ rows: 1 }} />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-12 col-lg-5 pr-md-0">
              <div className="d-md-flex">
                <span className="bg__white border border-radius-4 p-15 mb-sm-3 mr-md-3 w-100">
                  <Skeleton active size="small" paragraph={{ rows: 1 }} />
                </span>
                <span className="bg__white border border-radius-4 p-15 mb-sm-3 mr-md-3 w-100">
                  <Skeleton active size="small" paragraph={{ rows: 1 }} />
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(InfoBar, isEqual);
